import React from 'react';
import { Card, CardContent } from './ui/card';
import { revenueModelData } from '../data/mockData';
import { CheckCircle2, TrendingUp, Zap, DollarSign } from 'lucide-react';

const RevenueModel = () => {
  return (
    <section id="revenue-model" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {revenueModelData.sectionTitle}
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            {revenueModelData.explanation}
          </p>
        </div>

        {/* Revenue Split Visual */}
        <div className="max-w-4xl mx-auto mb-12">
          <Card className="overflow-hidden border-slate-200 shadow-xl">
            <CardContent className="p-0">
              <div className="grid md:grid-cols-2 divide-x divide-slate-200">
                {/* Creator Split */}
                <div className="p-12 bg-gradient-to-br from-blue-50 to-white text-center">
                  <div className="mb-4">
                    <DollarSign className="h-16 w-16 text-blue-600 mx-auto" />
                  </div>
                  <div className="text-7xl font-bold text-blue-600 mb-2">
                    {revenueModelData.split.creator}%
                  </div>
                  <p className="text-2xl font-semibold text-slate-900">You Keep</p>
                  <p className="text-slate-600 mt-2">Your revenue, your business</p>
                </div>

                {/* Aureon Media Split */}
                <div className="p-12 bg-gradient-to-br from-slate-50 to-white text-center">
                  <div className="mb-4">
                    <TrendingUp className="h-16 w-16 text-slate-600 mx-auto" />
                  </div>
                  <div className="text-7xl font-bold text-slate-700 mb-2">
                    {revenueModelData.split.aureonMedia}%
                  </div>
                  <p className="text-2xl font-semibold text-slate-900">We Earn</p>
                  <p className="text-slate-600 mt-2">Only when you succeed</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {revenueModelData.features.map((feature, index) => {
            const icons = [CheckCircle2, Zap, DollarSign];
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="flex items-center gap-4 p-6 bg-slate-50 rounded-lg border border-slate-200 hover:border-blue-400 hover:bg-blue-50 transition-all duration-300"
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <p className="text-lg font-semibold text-slate-900">{feature}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RevenueModel;
